/**
 * Workers module routes — moved verbatim from router/index.tsx.
 */

import { type RouteObject } from 'react-router-dom';
import { PK } from '@/constants/permissions';
import { ROUTES } from '@/constants';
import { lazyWithRetry } from '@/utils/lazyWithRetry';
import { PermissionRoute } from '../PermissionRoute';

// Workers pages
const WorkersListPage = lazyWithRetry(() => import('@/features/workers/pages/WorkersListPage'));
const WorkerDetailsPage = lazyWithRetry(() => import('@/features/workers/pages/WorkerDetailsPage'));
const WorkerCreatePage = lazyWithRetry(() => import('@/features/workers/pages/WorkerCreatePage'));
const WorkerEditPage = lazyWithRetry(() => import('@/features/workers/pages/WorkerEditPage'));
const AccountDeletionRequestsPage = lazyWithRetry(() => import('@/features/workers/pages/AccountDeletionRequestsPage'));

export const workersRoutes: RouteObject[] = [
      // --------------------------------
      // Workers Module
      // --------------------------------
      {
        path: ROUTES.workers.list,
        element: (
          <PermissionRoute permission={PK.Workers.View}>
            <WorkersListPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.workers.create,
        element: (
          <PermissionRoute permission={PK.Workers.Create}>
            <WorkerCreatePage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.workers.details,
        element: (
          <PermissionRoute permission={PK.Workers.View}>
            <WorkerDetailsPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.workers.edit,
        element: (
          <PermissionRoute permission={PK.Workers.Edit}>
            <WorkerEditPage />
          </PermissionRoute>
        ),
      },
      {
        path: ROUTES.workers.deletionRequests,
        element: (
          <PermissionRoute
            anyOf={[
              PK.Workers.DeleteRequestApprove,
              PK.Workers.DeleteRequestReject,
              PK.AccountDeletion.Review,
            ]}
          >
            <AccountDeletionRequestsPage />
          </PermissionRoute>
        ),
      },
];
